$(document).ready(function(){
  $(document).on('mouseover', 'header.header nav.header__inline-menu ul.list-menu li[itemid=BIgjO]', function(){
    $('header.header nav.header__inline-menu ul.list-menu li[itemid=BIgjO] > a.header__menu-item ~ ul > li[role="menuitem"], header.header nav.header__inline-menu ul.list-menu li[itemid=BIgjO] > a.header__menu-item ~ ul > li[role="menuitem"] > a')
    .removeAttr('rel onclick aria-hidden data-no-instant data-href');
  });
  $(document).one('mouseover', 'header.header nav.header__inline-menu ul.list-menu li[itemid="BIgjO"]', function () {
    $('header.header nav.header__inline-menu ul.list-menu li[itemid="BIgjO"] > a.header__menu-item ~ ul > li[aria-label="By Collection"]').addClass('sh');
  });
  $(document).on(
    'mouseover',
    'header.header nav.header__inline-menu ul.list-menu li[itemid="BIgjO"]',
    function () {
      if (!$('header.header nav.header__inline-menu ul.list-menu li[itemid="BIgjO"] > ul').find('.need_to_service').length) {
        $('header.header nav.header__inline-menu ul.list-menu li[itemid="BIgjO"] > ul').append(`
          <div class="need_to_service">
            <div>
              <h3 class="h3">Need to service your device?</h3>
              <p>We offer onsite or mail-in servicing Australia-wide for AEDs. Stay compliant and ready to save lives.</p>
              <a href="https://defibsplus.myshopify.com/pages/services" class="enquire_btn">enquire now</a>
            </div>
          </div>
        `);
      }
    }
  );
  $(document).on('mouseover', 'header.header nav.header__inline-menu ul.list-menu li[itemid=BIgjO] > a.header__menu-item ~ ul > li[role="menuitem"] > a', function(){
    $(this).parent().addClass('sh').siblings().removeClass('sh');
  });
});